import React from 'react';
import { MapPin } from 'lucide-react';
import { ServiceMap } from './ServiceMap';
const locations = ['Jefferson, GA', 'Commerce, GA', 'Monroe, GA', 'Lawrenceville, GA', 'Braselton, GA', 'Loganville, GA', 'Athens, GA', 'Winder, GA', 'Buford, GA', 'Watkinsville, GA'];
export function ServiceArea() {
  return <section className="py-24 bg-background relative" data-id="element-161">
      <div className="container mx-auto px-4" data-id="element-162">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-163">
          <div className="w-full lg:w-1/2" data-id="element-164">
            <h2 className="text-primary font-bold tracking-widest uppercase text-sm mb-3 flex items-center gap-2" data-id="element-165">
              <span className="w-8 h-[2px] bg-primary" data-id="element-166"></span>
              Area of Operations
            </h2>
            <h3 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight mb-6" data-id="element-167">
              Our Drop Zones
            </h3>
            <p className="text-muted-foreground text-lg mb-8" data-id="element-168">
              Based in Winder, GA, we deploy our cleanup squads across Northeast
              Georgia. If your site is in our AO (Area of Operations), we're
              ready to roll.
            </p>

            <div className="grid grid-cols-2 gap-4" data-id="element-169">
              {locations.map((loc, i) => <div key={i} className="flex items-center gap-2 text-foreground font-medium" data-id="element-170">
                  <MapPin className="w-4 h-4 text-primary" data-id="element-171" />
                  {loc}
                </div>)}
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-172">
            <div className="bg-card border border-border p-2 rounded-lg" data-id="element-173">
              <div className="aspect-video rounded overflow-hidden relative" data-id="element-174">
                <ServiceMap data-id="element-175" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}